import PropTypes from 'prop-types'
import React from 'react'
import Icon from '../Icon'
import './styles.scss'

const SocialLinks = ({ links, size, color }) => (
  <div className="social-links">
    {links.map((link, index) => (
      <a className="social-links__item" key={index} href={link.to} target="_blank" rel="noreferrer">
        <Icon name={link.icon} size={size === 'large' ? 28 : 24} fill={color} hoverFill="tertiary" />
      </a>
    ))}
  </div>
)

SocialLinks.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({ icon: PropTypes.string, to: PropTypes.string })),
  size: PropTypes.oneOf(['small', 'large']),
  color: PropTypes.string
}

SocialLinks.defaultProps = {
  size: 'small',
  color: 'primary'
}

export default SocialLinks
